/* eslint-disable @typescript-eslint/no-explicit-any */

/** https://docs.tsafe.dev/typeguard */
export function typeGuard(_value, isMatched) {
  return isMatched;
}